<template>
  <div class="">
    <div>
      <ul class="menu">
        <li style="font-size: 28px;font-weight: 500;">动态报告</li>
        <li class="menu-item sub-item" style="font-size: 20px;font-weight: 400;color: #757D8A;margin-top: 15px;">一键重分析
        </li>
      </ul>
    </div>

    <div style="margin-top: 50px;">


      <div class="item_content_line">项目名称：{{taskStore.template_config?.name_zh}}</div>
      <div class="item_content_line">任务名称：{{taskStore.current_task_name}}</div>

      <div style="margin-top: 20px;">

        <DynamicForm ref="dynamicForm" />
      </div>

    </div>

    <!-- <div style="margin-top: 50px;" v-if="false">
      <template v-for="(item, index) in form_list" :key="index">
        <div :class="{is_active: item.isOpen}" style="margin-bottom: 25px;">
          <div class="flex item_head">
            <div class="flex" style="gap: 30px;">
              <div class="item_index">{{ index + 1 }}</div>
              <div class="item_title">{{ item.title }}</div>
              <el-popover class="box-item" title="提示" :content="item.pro" placement="top-start">
                <template #reference>
                  <img v-if="item.isOpen" src="./img/Frame_2.png" alt="">
                  <img v-else src="./img/Frame.png" alt="">
                </template>
              </el-popover>
            </div>
            <div class="show_more" @click.stop="toggleItem(index)" :title="item.isOpen ? '收起' : '展开'">
              <img v-if="item.isOpen" src="./img/show_2.png" alt="">
              <img v-else src="./img/show_1.png" alt="">
            </div>
          </div>

          <div class="item_content" v-show="item.isOpen">
            <div class="item_intro" v-if="item.intro">{{ item.intro }}</div>
            <div>
              <template v-if="item.type === 'SelectFile'">
                <div class="item_content_line">项目名称：{{taskStore.template_config?.name_zh}}</div>
                <div class="item_content_line">任务名称：{{taskStore.current_task_name}}</div>
              </template>
              <template v-else-if="item.type === 'FileData'">
                <FileData></FileData>
              </template>
              <template v-else-if="item.type === 'GroupData'">
                <GroupData></GroupData>
              </template>
              <template v-else-if="item.type === 'ComparePlan'">
                <ComparePlan></ComparePlan>
              </template>
              <template v-else-if="item.type === 'FormData'">
                <DynamicForm ref="dynamicForm" />
              </template>
            </div>
          </div>
        </div>
      </template>
    </div> -->
    <div style="text-align: center;margin-top: 50px;">
      <!-- <el-button type="primary" @click="handleSubmit" style="width: 200px;height: 50px;border-radius: 40px;"
        :loading="is_submit_loading">一键运行</el-button> -->
      <el-button type="primary" @click="handleRun" style="width: 200px;height: 50px;border-radius: 40px;"
        :loading="is_submit_loading">一键运行</el-button>
    </div>
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';

  import { ElMessage, ElMessageBox } from 'element-plus'

  import SelectFile from "../FormComs/SelectFile.vue";
  import FileData from "../FormComs/FileData.vue";
  import GroupData from "../FormComs/GroupData.vue";
  import ComparePlan from "../FormComs/ComparePlan.vue";
  import DynamicForm from "../FormComs/DynamicForm.vue";

  import { useStore } from '@/Store/index';
  import { useTaskStore, useFormStore } from "@/Store/task.js";

  import { start_task, get_remaining_reanalysis_times } from "@/api/index.js";


  const store = useStore();
  const taskStore = useTaskStore();
  const formStore = useFormStore();

  const emit = defineEmits([])
  const props = defineProps({
    categoryName: {
      type: String,
    },
    rawData: {
      type: Object,
    }
  });


  const activeNames = ref(['1']);

  const handleChange = function (val) {
    console.log(val)
  };



  const dynamicForm = ref(null);



  const form_list = ref([
    {
      title: "当前分析项目",
      pro: "",
      type: "SelectFile",
      isOpen: true
    },
    {
      title: "筛选数据(按行)",
      pro: "选择需要展示的数据，支持按行筛选，可多选。",
      type: "FileData",
      isOpen: true
    },
    {
      title: "分组数据",
      pro: "按指定字段分组数据，可选择分组字段、分组方式、排序方式。",
      intro: `样本和组别的命名需遵循以下规范：命名必须以英文字母开头，长度不超过8个字符，可以包含字母、数字和下划线。组别命名不能使用任何连接符，样本命名如需连接只能使用英文下划线"_"，且不能连续使用多个下划线，命名中不得包含中文、罗马或希腊字符，也不能使用特殊符号如 |、？、：、\、/、@、#、$、%、*、括号"()"、方括号"[]"、中文括号"【】"、大括号"{}"等，同时需符合 Windows 文件命名规则，不允许出现系统禁止的字符。请避免使用可能被系统识别为特殊含义的单词或字符，如 NA、vs/VS/、nan、inf、None、none，并且不能包含文字的上下标。`,
      type: "GroupData",
      isOpen: true
    },
    {
      title: "设计分析差异方案",
      pro: "分析数据差异，设计差异方案，提升分析结果的可靠性。",
      type: "ComparePlan",
      isOpen: true
    },
    {
      title: "其他参数",
      type: "FormData",
      isOpen: true
    },
  ]);



  const schema = [
    {
      key: "gene_read.is_kegg_analysis",
      title: "是否进行KEGG通路分析：",
      assembly_type: "radio",
      default: true,
      is_required: true,
      select_data: [
        { label: "是", value: true },
        { label: "否", value: false }
      ]
    },
    {
      key: "gene_read.kegg_type",
      title: "KEGG通路类型：",
      assembly_type: "radio",
      default: "animals",
      is_required: true,
      select_data: [
        { label: "动物", value: "animals" },
        { label: "微生物", value: "hsa" },
        { label: "植物", value: "plants" },
        { label: "全部", value: "all" }
      ]
    },
    {
      key: "gene_read.vip_threshold",
      title: "VIP筛选阈值",
      assembly_type: "input",
      default: 1.5,
      is_required: true,
      prompt: "0表示不用VIP进行筛选，大于0表示使用VIP筛选差异物质，一般建议设置为1.5。"
    },
    {
      key: "gene_read.diff_threshold",
      title: "差异倍数筛选阈值",
      assembly_type: "input",
      default: 0.67,
      is_required: true,
    },
    {
      key: "gene_read.diff_threshold",
      title: "显著性Pvalue筛选阈值",
      assembly_type: "input",
      default: 0.05,
      is_required: true,
    },
    {
      key: "gene_read.is_show_logo",
      title: "是否展示公司logo：",
      assembly_type: "radio",
      default: true,
      is_required: true,
      select_data: [
        { label: "是", value: true },
        { label: "否", value: false }
      ]
    },
    {
      key: "gene_read.name",
      assembly_type: "input",
      title: "流程任务名称",
      default: "",
      is_required: true
    },
  ];



  const toggleItem = (index) => {
    /*  item.isOpen = !item.isOpen */
    form_list.value[index].isOpen = !form_list.value[index].isOpen;
  };

  function transformToObject(list) {
    return list.reduce((acc, item) => {
      acc[item.key] = item.default ?? null; // 没有 default 就给 null
      return acc;
    }, {});
  };


  const toPerson = function () {
    if (window.top === window) {
      console.log("无父级页面，不发送消息");
    } else {
      window.parent.postMessage({ type: "go_person_project_page", data: {} }, "*");
    }
  };

  const is_submit_loading = ref(false);
  const handleSubmit = async () => {
    try {
      // console.log("开始提交", dynamicForm.value);
      const values = await dynamicForm.value.submit();
      // console.log("输入数据:", values);

      const app_id = store.app_id;//应用id
      const task_id = store.task_id;//任务id
      const process_forms = formStore.process_forms;

      // console.log("当前流程参数", process_forms);

      if (!Array.isArray(process_forms) || process_forms.length === 0) {
        return ElMessage.error("未找到流程参数");
      };

      // 生成最终的提交数据
      const finalParams = {};
      process_forms.forEach((field) => {
        if (field.category === "metadata") {
          finalParams[field.key] = taskStore.metadata_file;
        } else if (field.category === "filter_data_row") {
          finalParams[field.key] = taskStore.filter_data_file;
        } else if (field.category === "comparison_group_plan") {
          finalParams[field.key] = taskStore.group_plan_file;
        } else {
          // 普通字段：优先取表单提交的值，否则 fallback 到原始值/默认值
          finalParams[field.key] =
            values[field.key] ?? field.value ?? field.default ?? null;
        }
      });

      const allProcessForms = transformToObject(formStore.all_process_forms);//转为表单数据
      const params = {
        input_data: {
          ...allProcessForms,
          ...finalParams
        },
        task_name: values.task_name,
        node_name: taskStore.start_node_name,
        app_id: app_id,
        task_id: task_id,
        is_multi_step: true,
        is_restart: true
      };

      console.log("要提交的最终表单", params);
      is_submit_loading.value = true;
      start_task(params).then((result) => {
        console.log("提交结果", result);
        if (result.code == 200) {
          is_submit_loading.value = false;
          ElMessage.success("提交成功");
          toPerson();
        }
      }).catch((err) => {
        console.error(err);
        ElMessage.error("提交失败");
        is_submit_loading.value = false;
      });


    } catch (err) {
      console.error(err);
    }
  };

  //
  //一键运行
  /*  const handleRun = () => {
 
     const task_id = store.task_id;
     let num = 0;
     if (task_id) {
       get_remaining_reanalysis_times({ task_id }).then((result) => {
         console.log("剩余重分析次数", result);
         if (result.code == 200) {
           num = result.message;
           const template = `本次一键重分析任务预计耗时 1小时，并会扣减 1 次使用次数（当前剩余 ${num}次)。请确认是否提交?`;
 
           ElMessageBox.confirm(
             template,
             'Warning',
             {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning',
             }
           ).then(() => {
             
 
           }).catch(() => {
            
           })
 
         }
       }).catch((err) => {
 
       });
     }
   }; */


  const handleRun = () => {
    const task_id = store.task_id;
    if (!task_id) return;
    get_remaining_reanalysis_times({ task_id }).then((result) => {
      console.log("剩余重分析次数", result);
      if (result.code == 200) {
        const num = result.message;
        //本次一键重分析任务预计耗时约3小时，实际耗时视数据量而定，并会扣减1次使用次数（当前剩余2次）。请确认是否提交。
        const template = `本次一键重分析任务预计耗时约3小时，实际耗时视数据量而定，并会扣减1次使用次数（当前剩余${num}次）。请确认是否提交?`;

        ElMessageBox.confirm(template, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          // ✅ 关键：这里能控制确认按钮 loading
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true; // 按钮进入 loading
              try {
                await handleSubmit(); // 调用你的提交逻辑
                instance.confirmButtonLoading = false;
                done(); // 成功后关闭弹窗
              } catch (err) {
                console.error("提交出错:", err);
                instance.confirmButtonLoading = false;
              }
            } else {
              done();
            }
          },
        })
          .then(() => {
            console.log("确认后关闭");
          })
          .catch(() => {
            console.log("取消");
          });
      }
    })
      .catch((err) => {
        console.error(err);
      });
  };


  // 使用 watch 监听 props 的字段变化
  watch(() => props.categoryName, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(() => {

    console.log("项目信息", props.rawData);

  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style lang="scss" scoped>
  .menu {
    list-style: none;
    padding-left: 20px;
  }

  .menu-item {
    position: relative;
    padding-left: 25px;
    /* 给前面的 L 留空 */
    line-height: 24px;
  }

  .sub-item::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 0;
    /* 横线长度 */
    width: 16px;
    /* 竖线高度 */
    height: 22px;
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    transform: translateY(-50%);
  }



  .item_head {
    height: 70px;
    background-color: #F4F5F6;
    border-radius: 8px;
    padding: 0 24px;
    box-sizing: border-box;
    /* justify-content: flex-start; */
    justify-content: space-between;


    .item_index {
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      /*  background-color: var(--el-color-primary); */


      border-radius: 100%;
      font-size: 16px;
      border: 1px solid #757D8A4D;
      color: #757D8A;
    }

    .item_title {
      font-size: 20px;
      font-weight: 400;
    }
  }

  .item_content {
    padding: 40px 20px;
    box-sizing: border-box;

    .item_intro {
      color: #333;
      font-size: 16px;
      margin-bottom: 26px;
    }
  }

  .show_more {
    width: 34px;
    height: 34px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    background-color: #D9D9D9;
  }

  .is_active {
    .item_head {
      background-color: var(--el-color-primary);

      .item_index {
        border: none;
        background-color: #fff;
        color: var(--el-color-primary);
      }

      .item_title {
        color: #fff;
      }

      .show_more {
        background-color: #fff;
      }
    }
  }

  .item_content_line {
    color: #333;
    font-size: 20px;
    font-weight: 500;
  }
</style>